import React from "react";
import {App, ConfigProvider, Spin} from "antd";
import {createStyles} from "antd-style";
import zhCN from "antd/locale/zh_CN.js";

const useStyles = createStyles((): any => {
    return {
        body: {
            width: "100%",
            margin: "0 auto",
            lineHeight: "80vh"
        },
    };
});

export default () => {
    const {styles: {body}} = useStyles();
    return (
        <ConfigProvider locale={zhCN}  theme={{ cssVar: true }}>
            <App>
                <Spin size="large" className={body}/>
            </App>
        </ConfigProvider>
    );
};